import actionTypes, { PayloadAction } from './actionTypes';
import { LicenseTier } from '../types/license';

export function receivedLicenseTiers(response: LicenseTier[]): PayloadAction<LicenseTier[]> {
    return {
        type: actionTypes.RECEIVED_LICENSE_TIERS,
        payload: response,
    };
}
